// extracted by extract-css-chunks-webpack-plugin
module.exports = {"coverage":"_2jg-Ax","modal":"_4i6XL0","open":"_3nSiz2","spinnerHolder":"_2sN0mK","errMsg":"_2PmnFE","headingWrapper":"_3SziTQ","heading":"ySd59M"};